import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Page } from 'src/app/classes/page';
import { AuditService } from 'src/app/services/audit.service';
import { ToastService } from 'src/app/toast/toast.service';

declare var bootstrap: any;
@Component({
  selector: 'app-assign-verifier',
  templateUrl: './assign-verifier.component.html',
  styleUrls: ['./assign-verifier.component.scss']
})
export class AssignVerifierComponent {
  // @ViewChild('confirmModal') confirmModal!: ElementRef;
  @ViewChild('confirmModal', { static: false }) confirmModal!: ElementRef;
id: number = 0;
  page = new Page();
  societyVerificationDetails: any[] = [];
  assignedVerifierDetails: any[] = [];
  designationsData: any[] = [];
  officerData: any[] = [];
  auditOfficerData: any[] = [];
  errorMessage: string = '';
  ddlDesignation: string = '';
  ddlRoleOfficer: string = '';
  totalConducted: number = 0;
  totalCompleted: number = 0;
  iSocietyDetailsId: number  | null = null;
  // lastThreeVerification:boolean = false;
  // lastThreeAudit:boolean = false;
  lastThreeVerification: boolean | null = null; 
  lastThreeAudit:boolean | null = null; 
  verifierName:string = '';
  designation:string = '';
  circle:string = '';
  mobileNo:string = '';
  emailId:string = '';
  column: any[] = [];
  configService: any;
  iSocietyDetailsTransId: number | null = null;
  constructor(private auditService: AuditService,private route: ActivatedRoute,private toastService: ToastService,
    private router: Router) { 
    {
      this.page.pageNumber = 0;
      this.page.pageSize = 10;
    }
  }

  ngOnInit(): void {
//     this.isocietydetailsid = Number(this.route.snapshot.paramMap.get('isocietydetailsid'));
//     this.id = Number(this.route.snapshot.paramMap.get('id'));
   
// if(this.id==0){
//   this.updateStatus(this.isocietydetailsid,'Inprocess');
// }

this.route.paramMap.subscribe(params => {
  const societyIdParam = params.get('isocietydetailsid');
  const transIdParam = params.get('transId');

  this.iSocietyDetailsId = societyIdParam ? +societyIdParam : null;
  this.iSocietyDetailsTransId = transIdParam ? +transIdParam : 0;


  if (this.iSocietyDetailsTransId && this.iSocietyDetailsId !== null) {
    this.bindDesignation();  
    this.getSocietyVerificationDetails(this.iSocietyDetailsId);
  } else {
    console.warn("Invalid or missing route params");
  }

  if (this.iSocietyDetailsId === 0) {
    this.updateStatus(this.iSocietyDetailsId, 'Inprocess');
  }
});




this.column = [
  { prop: 'departmentalAudit', name: 'Departmental Audit' },
  { prop: 'verifierEmail', name: 'Email Id' },
  { prop: 'verifierMobile', name: 'Mobile No.' },
  { prop: 'verifierName', name: 'Name' },
  { prop: 'year', name: 'Year' },
  // { prop: 'status', name: 'Status' }
];
  }

  updateStatus(societydetailsid:number,action:string): void {

    // const data = {
    //   societydetailsid: this.isocietydetailsid,
    //   action: 'Inprocess'
    // };
    this.auditService.updateAuditStatus(societydetailsid,action,0).subscribe(
      (response) => {
        if (response.status === 200) {

          this.toastService.showSuccess(response.message);
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error assigning verifier: ' + error.message;
        console.error('Error assigning verifier:', error);
      }
    );
  }

  getSocietyVerificationDetails(isocietydetailsid:number): void {
    this.auditService.getSocietyVerificationDetails(isocietydetailsid).subscribe(
      (response) => {
   
        if (response.status === 200) {
          this.societyVerificationDetails = response.data;
          
        } else {
          // this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error fetching society verification details: ' + error.message;
        console.error('Error fetching society verification details:', error);
      }
    );
  }

  bindDesignation(): void {
  
    this.auditService.bindDesignation().subscribe(
      (response) => {
   
        if (response.status === 200) {
          this.designationsData=response.data.designations;
        } else {    
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }

  onDesignationChange(event: Event): void {
    const selectedId = Number((event.target as HTMLSelectElement).value);
    this.auditService.bindOfficer(selectedId,this.iSocietyDetailsId).subscribe(
      (response) => {
   
        if (response.status === 200) {
          this.officerData=response.data.officer;

        } else {    
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }




  onRoleOfficerChange(event: Event): void {
    const selectedId = Number((event.target as HTMLSelectElement).value);
    this.auditService.getAuditOfficerDetail(selectedId).subscribe(
      (response) => {
        if (response.status === 200 && response.data && response.data.length > 0) {
          const officer = response.data[0];

          this.totalConducted = officer.totalAuditConducted ?? 0;
          this.totalCompleted = officer.totalCompletedAudit ?? 0;

          this.lastThreeVerification = officer.isPartOfLastThreeVerification ?? null;
          this.lastThreeAudit = officer.isPartOfLastThreeAudit ?? null;

          this.verifierName = officer.name ?? '-';
          this.designation = officer.designation ?? '-';
          this.circle = officer.sCircleName ?? '-';
          this.mobileNo = officer.mobile ?? '-';
          this.emailId = officer.email ?? '-';

        } else {
          // Clear fields when no data is found
          this.resetFields();
          this.toastService.showError(response.message || 'No data found');
        }
      },
      (error) => {
        this.resetFields();
        this.errorMessage = 'Error fetching data: ' + error.message;
        console.error('Error fetching data:', error);
      }
    );
}

// Reset function to clear data
resetFields(): void {
    this.totalConducted = 0;
    this.totalCompleted = 0;
    this.lastThreeVerification = null;
    this.lastThreeAudit = null;
    this.verifierName = '-';
    this.designation = '-';
    this.circle = '-';
    this.mobileNo = '-';
    this.emailId = '-';
}


  assignVerifier(verifierForm: NgForm): void {

    if (verifierForm.invalid) {
      this.toastService.showError('Please fill all required fields correctly.');
      return;
    }
     const id = Number(this.ddlRoleOfficer);
    // const data = {
    //   iSocietyDetailID: this.isocietydetailsid,
   
    //   iUserID: this.ddlRoleOfficer
    // };
    
    if(this.iSocietyDetailsId !== null)
    {
    this.auditService.updateAuditStatus(this.iSocietyDetailsId,"InAssign",id).subscribe(
      (response) => {
        if (response.status === 200) {
          this.totalConducted = 0;
          this.totalCompleted = 0;
          this.lastThreeVerification = null;
          this.lastThreeAudit = null;
          this.verifierName = '';
          this.designation = '';
          this.circle = '';
          this.mobileNo = '';
          this.emailId = '';
          this.toastService.showSuccess(response.message);
          this.router.navigate(['/dashboard']);
         // this.router.navigate(['/audit/assignedsociety', 2]);
          
          // this.router.navigate(['/audit/assignedsociety']);
          
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error assigning verifier: ' + error.message;
        console.error('Error assigning verifier:', error);
      }
    );
  }
  }

  // openConfirmModal() {
  
  //   const modalElement = this.confirmModal.nativeElement;
  //   const modalInstance = new bootstrap(modalElement);
  //   modalInstance.show();
  //   this.router.navigate(['/audit/assignedsociety',this.isocietydetailsid]);
  // }

  downloadFile(fileName: string) {
    
    if (fileName === '' || fileName === null) {
      this.toastService.showError('File not found');
      return;
    }
    const fileUrl = this.configService.getFileUrl() + fileName;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank';
    link.click();
  }
  openConfirmModal() {
    
    
    // if (this.confirmModal) {
    //   const modalElement = this.confirmModal.nativeElement;
    //   const modalInstance = new bootstrap.Modal(modalElement); // ✅ Correct way to initialize Bootstrap Modal
    //   modalInstance.show();

      
    // } else {
    //   console.error("Modal element not found!");
    // }
  }


  // getAssignedVerifierDetails(): void {
  //   this.auditService.getAssignedVerifierDetails().subscribe(
  //     (response) => {
  //       if (response.status === 200) {
  //         this.assignedVerifierDetails = response.data;
  //       } else {
  //         this.toastService.showError(response.message);
  //       }
  //     },
  //     (error) => {
  //       // Handle any errors that occur during the request
  //       this.errorMessage = 'Error fetching assigned verifier details: ' + error.message;
  //       console.error('Error fetching assigned verifier details:', error);
  //     }
  //   );
  // }

  setPage(pageInfo: any): void {
    this.page.pageNumber = pageInfo.offset;
    //this.getSocietyVerificationDetails();
  }

  onSearch(): void {
    //this.getSocietyVerificationDetails();
  }

  onReset(): void {
    this.ddlDesignation = '';
    this.ddlRoleOfficer = '';
    this.totalConducted = 0;
    this.totalCompleted = 0;
  }


}
